// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .mat-dialog-container {
  overflow: visible !important;
}

::ng-deep eqp-dynamic-filters .filter-mat-card-header {
  margin-top: 10px !important;
  border-radius: 5px !important;
}

::ng-deep eqp-dynamic-filters .mat-card {
  box-shadow: 0px 0px 5px 0px rgba(0, 0, 0, 0.44) !important;
  width: 98% !important;
  margin-left: 1% !important;
}

::ng-deep eqp-dynamic-filters .col-sm-4.text-right .btn.mr-1 {
  background-color: #9a9a9a !important;
  color: white !important;
}`, "",{"version":3,"sources":["webpack://./src/app/components/report-companies/report-companies.component.scss"],"names":[],"mappings":"AACI;EACA,4BAAA;AAAJ;;AAKA;EACE,2BAAA;EACA,6BAAA;AAFF;;AAKA;EACA,0DAAA;EACA,qBAAA;EACA,0BAAA;AAFA;;AAKA;EACA,oCAAA;EACA,uBAAA;AAFA","sourcesContent":["::ng-deep {\r\n    .mat-dialog-container {\r\n    overflow: visible !important;\r\n\r\n    }\r\n}\r\n\r\n::ng-deep eqp-dynamic-filters .filter-mat-card-header{\r\n  margin-top: 10px !important;\r\n  border-radius: 5px !important;\r\n}\r\n\r\n::ng-deep eqp-dynamic-filters .mat-card{\r\nbox-shadow: 0px 0px 5px 0px rgba(0,0,0,0.44) !important;\r\nwidth: 98% !important;\r\nmargin-left: 1% !important;\r\n}\r\n\r\n::ng-deep eqp-dynamic-filters .col-sm-4.text-right .btn.mr-1{\r\nbackground-color: #9a9a9a !important;\r\ncolor: white !important;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
